export const brandColors = {
  primary: '#1a5f4a',
  primaryLight: '#2d7a62',
  primaryBg: '#e8f4ef',
};

export const antTheme = {
  token: {
    colorPrimary: brandColors.primary,
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#1677ff',
    colorBgLayout: '#f0f2f5',
    colorBgContainer: '#ffffff',
    colorTextSecondary: '#8c8c8c',
    borderRadius: 6,
    borderRadiusLG: 8,
    boxShadowSecondary: '0 2px 8px rgba(0, 0, 0, 0.06)',
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  components: {
    Card: {
      boxShadowTertiary: '0 1px 4px rgba(0, 0, 0, 0.06)',
    },
    Table: {
      rowHoverBg: '#f5f9f7',
    },
    Layout: {
      headerBg: '#ffffff',
      bodyBg: '#f0f2f5',
      siderBg: '#001529',
    },
  },
};

export const kpiAccents = {
  primary: { color: brandColors.primary, bg: brandColors.primaryBg },
  success: { color: '#52c41a', bg: '#f6ffed' },
  warning: { color: '#faad14', bg: '#fffbe6' },
  error: { color: '#ff4d4f', bg: '#fff2f0' },
  default: { color: '#595959', bg: '#f5f5f5' },
};
